import { requireImgAssets } from '@/utils/utils'

const data = {
  internationalLogisticsService: ($pconf) => [
    {
      title: 'modules.home.intService', // 国际物流服务
      subTitle: 'modules.home.intTips', // 安全、高效、高品质的国际物流服务
      children: [
        {
          title: 'modules.home.courierService', // 快递服务
          // img: requireImgAssets('@/assets/img/home/product_01.png'),
          img: requireImgAssets('@/assets/img/home/product_bg_new_01.svg'),
          imgAlt: 'kuaidi',
          path: '/product',
          params: { query: { subProduct: 'express' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_01.png'),
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_01.png'),
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_new_01.svg'),
          img_mb: requireImgAssets('@/assets/img/home/product_mb_vn_th_my_sg_ph.png'),
          track: 'express_delivery_click|快递服务点击率',
          description:
            'modules.logisticsService.productList.expressDescription',
          children: [
            {
              title: 'modules.logisticsService.productList.fast', // 国际标快
              subTitle: 'modules.home.tipVn1', // 近洋流向,覆盖全球12个国家和地区,越南-中国核心城市次日达
              path: '/product/fast',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.fastPlus', // 国际标快+
              subTitle: 'modules.home.tipVn2', // 欧美流向,覆盖全球46个国家和地区
              path: '/product/fastPlus',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.discts', // 国际特惠
              subTitle: 'modules.home.tipVn3', // 高性价比快递；自营全货机直飞航班
              path: '/product/discts',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.bulk', // 国际大件
              subTitle: 'modules.home.tipVn4', // 高重量段经济型包裹；自营全货机直飞航班
              path: '/product/bulk',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ],
        },
        {
          title: 'modules.home.electService', // 电商服务
          img: requireImgAssets('@/assets/img/home/product_bg_new_02.svg'),
          imgAlt: 'kuaidi',
          path: '/product',
          params: { query: { subProduct: 'e-commerce' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_02.png'),
          img_mb: requireImgAssets('@/assets/img/home/product_mb_new_02.svg'),
          track: 'ecommerce_service_click|电商服务点击率',
          description:
            'modules.logisticsService.productList.ecommerceDescription',
          children: [
            {
              title: 'modules.logisticsService.productList.delivery', // 国际电商专递
              subTitle: 'modules.home.tipVn5', // 门到门电商小包服务,≤12kg包裹
              path: '/product/delivery',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ],
        },
        // 供应链服务
        {
          title: 'modules.logisticsService.productList.supplyChain', //
          img: requireImgAssets('@/assets/img/home/product_bg_new_03.png'),
          imgAlt: 'dianshang',
          path: '/product',
          params: { query: { subProduct: 'e-commerce' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_02.png'),
          img_bg2: '~/assets/img/home/product_mb_new_03.png',
          img_mb: requireImgAssets('@/assets/img/home/product_mb_new_03.png'),
          track: 'ecommerce_service_click|电商服务点击率',
          description:
            'modules.logisticsService.productList.ecommerceDescription',
          children: [
            {
              title:
                'modules.logisticsService.productList.endToEndSupplyChain', // 端到端供应链服务
              subTitle: 'modules.home.tipVn6', // 提供仓到门、厂到仓、仓到仓多种客制化服务
              path: '/product/endToEndSupplyChain',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.endDeliveryNetwork', // 完善的末端派送网络
              subTitle: 'modules.home.tipVn7', // 全国范围内B2B/B2C派送，支持整车运输与零担配送
              path: '/product/endDeliveryNetwork',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.multiTypeWarehousing', // 多类型仓储
              subTitle: 'modules.home.tipVn8', // 包含保税仓、CFS 、普通仓、温控仓、EPE延展仓、线边仓等
              path: '/product/multiTypeWarehousing',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ]
        },
        // 国际货代
        {
          title: 'modules.logisticsService.productList.internationalFreightForwarder', //国际货代
          img: requireImgAssets('@/assets/img/home/product_bg_new_04.png'),
          imgAlt: 'huodai',
          path: '/product',
          params: { query: { subProduct: 'e-commerce' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_02.png'),
          img_bg2: '~/assets/img/home/product_mb_new_04.png',
          img_mb: requireImgAssets('@/assets/img/home/product_mb_new_04.png'),
          track: 'ecommerce_service_click|电商服务点击率',
          description:
            'modules.logisticsService.productList.ecommerceDescription',
          children: [
            {
              title:
                'modules.logisticsService.productList.airTransportation', // 空运
              subTitle: 'modules.home.tipVn9', // 与18+家航司达成深度合作，每年稳定投入百万级美金保证金，以确保在航线资源获取、舱位调配及制单流程中保持更高优先级与操作弹性
              path: '/product/airTransportation',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.seaTransportation', // 海运
              subTitle: 'modules.home.tipVn10', // 与17+家船司达成深度合作，与广大船司有良好的合作关系，优势航线覆盖亚洲、欧洲及美洲大陆，特别是日韩航线
              path: '/product/seaTransportation',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.landCarriage', // 陆运
              subTitle: 'modules.home.tipVn11', // 营运车辆280+台，以越南为“中南半岛”枢纽，覆盖中国及东南亚 8 国的跨境陆运网络，并在主要口岸设立办事处，为客户提供高性价比的跨境陆运方案
              path: '/product/landCarriage',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ]
        },
      ],
    },
  ],
}

export default data
